module.exports = __webpack_public_path__ + "img/playground-marker.fb4b22d4.png";